var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 185,
    viewBox: "0 0 168 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.799 171.134L23.8373 0.463257L63.5 0.463257L167.5 67.5L167.5 100.5L74.7802 44.5L88 44.5L154.5 83L154.5 67.5L63.5 12.0431L44.367 11.4078L167.33 182.576L127.83 182.683L119.799 171.205L145.799 171.134Z",
    fill: "#066AB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 55L40.9547 43.9172L0.954895 44.0252L100.833 183.756L114.833 183.718L21.5 55L48.5 55Z",
    fill: "#066AB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6024 66.7775L115.155 160.131",
    stroke: "#066AB7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.d81d8f4b6d3be62db2d98c9e5de1d944.svg";
export { ForwardRef as ReactComponent };